module.exports = __webpack_public_path__ + "img/tingshou2.ab1bb168.png";